import Decimal from 'decimal.js'

export const validateDecimalPlaces = (value: number | string | Decimal, maxPlaces: number): boolean => {
  if (value === null || value === undefined) return true

  const decimal = new Decimal(value)

  return decimal.decimalPlaces() <= maxPlaces
}
